import React, { useCallback, useEffect, useState } from 'react';
import styles from './OrderCenter.module.less';
import ClassOrders from './ClassOrders/ClassOrders';
import MallOrders from './MallOrders/MallOrders';
import AppEquity from './AppEquity/AppEquity';
import Default from '../../static/order_lack.svg';
import Wallpaper from './Wallpaper/Wallpaper';
import Game from './GameOrder/GameOrder';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { PCStoreJsBridge } from '../../nativeapi';
import { logging, logPostInfo } from '../../actions/log';
import { getAppsList, getGoodsList, emptyList } from '../../actions/order';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import KeepAlive, { useAliveController, useActivate, useUnactivate } from 'react-activation';
import {
  Switch,
  Route,
  NavLink,
  useRouteMatch,
  Redirect,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { CONTEXT } from '../../config';
import AppPrompt from './Card/AppPrompt/AppPrompt';

const tabs = [
  { id: 4, name: '商城订单', path: 'mallorders' },
  { id: 1, name: '应用权益', path: 'appequity' },
  // { id: 2, name: '壁纸订单', path: 'wallpaper' },
  // { id: 3, name: '课程订单', path: 'classorders' },
  { id: 5, name: '其他订单', path: 'gameorders' },
];
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectAppList = createSelector(
  state => state.order,
  order => order,
);

function OrderCenter() {
  const loginStatus = useLoginStatus();
  const history = useHistory();
  const [activeId, setActionId] = useState(4);
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  const { path, url } = useRouteMatch();
  const { pathname } = useLocation();
  const [scrollNode, setScrollNode] = useState(null);
  const { appOrders, appTotal, appLoading } = useSelector(selectAppList);

  const handleClick = item => {
    setActionId(item.id);
    history.push(`${CONTEXT}/ordercenter/${item.path}`);
  };

  useEffect(() => {
    if (!loginStatus) {
      dispatch(emptyList());
    }
  }, [loginStatus]);

  const handleOpenPath = id => {
    PCStoreJsBridge.getWallpaperDPath({}).then(ret => {
      if (ret && ret.defpath) {
        PCStoreJsBridge.openFolder(ret.workpath || ret.defpath);
      }
    });

    // dispatch(
    //   logging({
    //     category: 'Wallpaper',
    //     action: 'C_Wallpaper_Openpath',
    //     param2: {
    //       source: `Wallpaper_Mine||paylist`,
    //       source_p: logInfoData.source_p,
    //       source_pp: logInfoData.source_pp,
    //       tagId: 'paylist',
    //     },
    //   }),
    // );
  };

  const handleErr = useCallback(() => {
    switch (activeId) {
      case 1:
        window.open(`https://wpa1.qq.com/D8V0UbWY?_type=wpa&qidian=true`);
        break;
      case 2:
        window.open(`https://wpa1.qq.com/z914HEIy?_type=wpa&qidian=true`);
        break;
      case 3:
        window.open(`https://wpa1.qq.com/z914HEIy?_type=wpa&qidian=true`);
        break;
      case 4:
        window.open(`https://wpa1.qq.com/F6XQcUh8?type=wpa&gidian=true`);
        break;
      case 5:
        window.open(`https://wpa1.qq.com/Db8QBBcG?_type=wpa&qidian=true `);
        break;
    }

    dispatch(
      logging({
        category: 'C',
        action: 'Orders_Error',
        label: '',
        param2: {
          source: 'Orders',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        },
      }),
    );
  }, [activeId]);

  const handelLogin = () => {
    window && window.CallNativeMethod && window.CallNativeMethod('login');
  };

  return (
    <div className={styles.order_center}>
      <div className={styles.content}>
        <nav className={styles.menu}>
          <div className={styles.menu_tabs}>
            {tabs.map(item => (
              <div
                onClick={() => handleClick(item)}
                key={item.id}
                className={`${styles.menu_item} ${
                  pathname === `${url}/${item.path}` ? styles.active : ''
                }`}
              >
                {item.name}
              </div>
            ))}
          </div>
          <div className={styles.order_err}>
            {pathname === `${CONTEXT}/ordercenter/wallpaper` && (
              <div className={styles.order_err_item} onClick={handleOpenPath}>
                <span className={styles.pay_opt_path_wj} />
                <span>打开下载目录</span>
              </div>
            )}

            <div className={styles.order_err_item} onClick={handleErr}>
              <span className={styles.pay_opt_path_wt} />
              <span>联系客服</span>
            </div>
          </div>
        </nav>
      </div>
      {activeId === 1 && <AppPrompt />}
      <div className={activeId === 1 ? styles.app_info : styles.info} ref={r => setScrollNode(r)}>
        <Switch>
          <Route exact path={`${url}/appequity`}>
            <AppEquity node={scrollNode} />
          </Route>
          <Route exact path={`${url}/mallorders`}>
            <MallOrders node={scrollNode} />
          </Route>
          <Route exact path={`${url}/gameorders`}>
            <Game node={scrollNode} />
          </Route>
          <Redirect to={`${CONTEXT}/ordercenter/mallorders`} />
        </Switch>
        {/* )} */}
      </div>
    </div>
  );
}

export default () => (
  <KeepAlive>
    <OrderCenter />
  </KeepAlive>
);
